import { render, staticRenderFns } from "./MobileFetchData.vue?vue&type=template&id=5a694217&scoped=true&"
import script from "./MobileFetchData.vue?vue&type=script&lang=js&"
export * from "./MobileFetchData.vue?vue&type=script&lang=js&"
import style0 from "./MobileFetchData.vue?vue&type=style&index=0&id=5a694217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a694217",
  null
  
)

export default component.exports